/**
 * Collection Page Widget Registry
 * Pure WidgetType → widget mapping. SSR collection feature flags are consumed
 * via useCollectionFeature() context inside individual widgets that need them.
 */

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { asBaseWidget, PageWidgetRegistry } from '@src/components/pl-base-widget'
import { BreadcrumbsWidget } from '@src/components/widgets/breadcrumbs'
import { CollectionBannerWidget } from '@src/components/widgets/collection-banner'
import { CollectionNavCarouselWidget } from '@src/components/widgets/collection-nav-carousel'
import { TitleWidget } from '@src/components/widgets/collection-title'
import { FAQWidget } from '@src/components/widgets/faq'
import { FilterAndSortWidget } from '@src/components/widgets/filter-and-sort-widget'
import { NoContentWidget } from '@src/components/widgets/no-content'
import { ProductCountWidget } from '@src/components/widgets/product-count-widget'
import { ProductGridWidget } from '@src/components/widgets/product-grid'
import { ProductRecommendationsWidget } from '@src/components/widgets/product-reco'
import { RichTextWidget } from '@src/components/widgets/rich-text'

export function getWidgetRegistry(): PageWidgetRegistry {
  return {
    [WidgetType.TITLE]: asBaseWidget(TitleWidget),
    [WidgetType.BREADCRUMBS]: asBaseWidget(BreadcrumbsWidget),
    [WidgetType.FILTER_AND_SORT]: asBaseWidget(FilterAndSortWidget),
    [WidgetType.PRODUCT_COUNT]: asBaseWidget(ProductCountWidget),
    [WidgetType.PRODUCT_LIST]: asBaseWidget(ProductGridWidget),
    [WidgetType.HORIZONTAL_PRODUCT_LIST]: asBaseWidget(ProductRecommendationsWidget),
    [WidgetType.FAQ]: asBaseWidget(FAQWidget),
    [WidgetType.NO_CONTENT]: asBaseWidget(NoContentWidget),
    [WidgetType.COLLECTION_NAV_CAROUSEL]: asBaseWidget(CollectionNavCarouselWidget),
    [WidgetType.RICH_TEXT]: asBaseWidget(RichTextWidget),
    [WidgetType.COLLECTION_BANNER]: asBaseWidget(CollectionBannerWidget),
  }
}
